import Moment from "moment";

const fixturesReducer = (state= {items:[]},action)=>{
    switch (action.type) {
        case 'FIXTURES':
            return {
                items: [ action.payload],

            };
        case 'FIXTURE_ADD':
            return { items: [...state.items, action.payload] };
        case 'FIXTURE_PREPEND':
            return { items: [action.payload, ...state.items] };
        default:
            return state;

    }
}
export default fixturesReducer;